/*
 * Generated by orval v3.2.3 🍺
 * Do not edit manually.
 * BFF Providers Api
 * OpenAPI spec version: v1
 */

export type Author = 'CUSTOMER' | 'PROVIDER' | 'WORKER' | 'PLUXEE';

export const Author = {
  CUSTOMER: 'CUSTOMER' as Author,
  PROVIDER: 'PROVIDER' as Author,
  WORKER: 'WORKER' as Author,
  PLUXEE: 'PLUXEE' as Author,
};
